// встроенная валидация имейла yup (yup.string().email()) недостаточно строгая
// и допускает очень некорректные значения
export const EMAIL_REGEX_FOR_VALIDATION =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}))$/;

export const DIALOG_ID_STORAGE_KEY = 'voice_ai_dialog_id';
